import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL = URLConfig.TRANSACTION;

export const TransactionMenuLink: Array<LinkItemProps> = [
  {
    name: "Consult. t. non traitées",
    link: URL.CONSULT_UNPROCESSED_TRANSACTIONS,
    level: 1,
  },
  {
    name: "Maint. t. non traitées",
    link: URL.MAINTENANCE_UNPROCESSED_TRANSACTIONS,
    level: 1,
  },
  {
    name: "Consult. t. traitées",
    link: URL.CONSULT_PROCESSED_TRANSACTIONS,
    level: 1,
  },
  {
    name: "Consult. t. dupliquées",
    link: URL.CONSULT_DUPLICATED_TRANSACTIONS,
    level: 1,
  },
];

